import { JsonpClientBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import Base64 from 'crypto-js/enc-base64';

declare var JSEncrypt: any;

@Injectable({
  providedIn: 'root'
})
export class AESEncryptDecryptService {
  key1:String = "-----BEGIN PUBLIC KEY-----MFswDQYJKoZIhvcNAQEBBQADSgAwRwJARrtd87Xh6THjHVO2U+7D+KdInkYbA0QtE/a0bVd8XJ2i6G8VFEpKcu3ewiT5JcGTyW8/EjjMCzDiFSOOtuC3yQIDAQAB-----END PUBLIC KEY-----";
  key2:String = "-----BEGIN PUBLIC KEY-----MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgG2To0DjDwajd+8sImkw9WcEqrsZSJr3Vj6VpL/8D3k7jKe2f5N58By7pVOEsBhjAaHiHvffALWE+nduocg85F0SCluIZhIi5I1esnUDkLPkdyhnjBmlhrk7U9fNn/pH3Kh1yP7C8z3BR2K8/RLSbNlznUuogPKn87eUj9Lt8DwdAgMBAAE=-----END PUBLIC KEY-----";

  constructor() { }

  randomString(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

  generateKey(){
    const encrypt1 = new JSEncrypt();
    encrypt1.setPublicKey(this.key1);
    return encrypt1.encrypt(`***${this.randomString(10)}***"`);
  }

  encrypt(data, key){
    const encrypt2 = new JSEncrypt();
    encrypt2.setPublicKey(this.key2);
    let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), key);
    let encryptedKey = encrypt2.encrypt(key);
    let encryptData = {"_":encryptedKey.toString(),"__":ciphertext.toString()};
    return encryptData;
  }

  
  decrypt(data, key){
    let decryptData = CryptoJS.AES.decrypt(data._, key);
    const utfString = decryptData.toString(CryptoJS.enc.Utf8);
    if(this.isJSON(utfString)){
      let jsonData = JSON.parse(utfString);
      return jsonData;
    }else{
      return {"response" : "Invalid Json"};
    }
  }

  isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
  } 
}
